import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Loading } from '@gpstrackit/react-controls';
import { useIntl } from 'react-intl';

//Components
import { Typography } from '@mui/material';
import { Bar } from 'react-chartjs-2';

//Actions
import {
    maintenanceWarningsDetailsOpenModal,
    chartDashboardPanel
} from 'Redux/actions';

//Styles
import './index.scss';
const StackedBar = (props) => {
    const { item, update } = props
    const dispatch = useDispatch();
    const { locale, messages } = useIntl();

    //Redux States
    const { updateResponse } = useSelector((state) => state.dashboardPanelMainRedux);
    const { charts_data } = useSelector(state => state.gadgetChartRedux);

    //Local States
    const [chartData, setChartData] = useState({});
    const [flag, setFlag] = useState(0);

    useEffect(() => {
        if (updateResponse) {
            if (updateResponse.id == item.id) {
                dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
                setChartData({});
            }
        }
    }, [updateResponse])

    const generateColor = () => {
        let r = Math.floor(Math.random() * 256);
        let g = Math.floor(Math.random() * 256);
        let b = Math.floor(Math.random() * 256);
        let color = "rgb(" + r + "," + g + "," + b + ")";
        return color;
    }

    useEffect(() => {
        dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
        setChartData({});
    }, [update]);

    useEffect(() => {
        if (+charts_data?.id === +item.id) {
            let currentData = charts_data.data
            currentData = {
                ...currentData,
                datasets: currentData?.datasets ? currentData.datasets.map((item) => ({ ...item, backgroundColor: generateColor() })) : []
            }
            setChartData(currentData)
            if (charts_data?.error && flag === 2) {
                dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
                setFlag(flag + 1)
            }
        }
    }, [charts_data]);

    useEffect(() => {
        if (charts_data?.error && charts_data?.id == item.id) {
            dispatch(chartDashboardPanel({ id: parseInt(item.id) }));
        }
    }, [locale]);
    
    return (
        <>
            {!chartData.hasOwnProperty('labels') &&
                <Loading overlay show />
            }
            <div className="title_chart">
                <Typography className="content-text" style={{ fontSize: '0.9 rem' }}>
                    {
                        chartData && chartData?.labels?.length ? `${chartData?.labels[0]} ${messages['dashboardPanel_to']} ${chartData?.labels[chartData?.labels.length - 1]}` : ''
                    }
                </Typography>
            </div>
            <div className="body_chart" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {
                    chartData?.datasets &&
                    <Bar
                        data={chartData}
                        options={{
                            responsive: true,
                            scales: {
                                x: {
                                    stacked: true,
                                    //display: false,
                                    min: 0,
                                },
                                y: {
                                    stacked: true,
                                    min: 0,
                                },
                            },
                            plugins: {
                                title: {
                                    display: true,
                                    text: messages['units'],
                                    position: "left"
                                }
                            },
                            /* legend: {
                                display: true,
                                position: "bottom",
                        
                              }, */
                            onClick: (event, elements) => {
                                if (elements.length > 0) {
                                    try {
                                        const clickedDatasetIndex = elements[0].datasetIndex;
                                        const labels = chartData.datasets[clickedDatasetIndex].label;
                                        const date = chartData.labels[elements[0].index];
                                        dispatch(maintenanceWarningsDetailsOpenModal(true, { label: labels, date: date, gadgetId: item.id }))
                                    } catch (error) {

                                    }
                                }
                            }
                        }} />
                }
            </div>
        </>
    )
}

export default StackedBar;